export const STAFF_VERIFICATION_EVENT = 'mediasfu:staff-verification-required';

export function staffSessionUrl(baseUrl) {
  const url = new URL(baseUrl, window.location.origin);
  if (!/^https?:$/.test(url.protocol) || url.username || url.password || url.search || url.hash ||
      !/\/api(?:\/graphql)?\/?$/.test(url.pathname)) throw new Error('Invalid authentication endpoint.');
  return `${url.origin}${url.pathname.replace(/\/api(?:\/graphql)?\/?$/, '/api/auth/staff-session')}`;
}

export async function staffSessionRequest(baseUrl, token, action = '', body, {
  fetchImpl = fetch, signal, requiredOnLegacy = process.env.REACT_APP_STAFF_SESSION_VERIFICATION_REQUIRED === 'true',
} = {}) {
  if (!token || token.includes(':')) throw new Error('A dashboard session is required.');
  if (!['', '/challenge', '/verify', '/logout'].includes(action)) throw new Error('Invalid verification action.');
  const response = await fetchImpl(staffSessionUrl(baseUrl) + action, {
    method: action ? 'POST' : 'GET', headers: { Accept: 'application/json',
      'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    ...(action ? { body: JSON.stringify(body || {}) } : {}), signal, cache: 'no-store',
    // Verification proof is on the server session, not an extra readable cookie.
  });
  // Frontend-first compatibility only. Enforced deployments must fail closed.
  if (!action && response.status === 404 && !requiredOnLegacy)
    return { success: true, required: false, verified: false, legacy: true };
  if (!String(response.headers.get('content-type') || '').includes('application/json'))
    throw new Error('Staff verification service is not ready.');
  const result = await response.json();
  if (!response.ok || result?.success !== true) {
    const error = new Error(result?.error || 'Staff verification unavailable.');
    error.code = result?.code; error.status = response.status; throw error;
  }
  if (!action && (typeof result.required !== 'boolean' || typeof result.verified !== 'boolean'))
    throw new Error('Staff verification response is invalid.');
  return result;
}
